import { useCallback, useEffect, useState } from 'react';
import { supabase } from './supabase';

// Module-level singleton so every <Sidebar> (and any future logo consumer)
// shares the same config and gets live-updated when one of them edits it.
let cached = null;
let loaded = false;
let inflight = null;
const listeners = new Set();

function notify() {
  for (const setter of listeners) setter(cached);
}

async function fetchConfigOnce() {
  if (inflight) return inflight;
  inflight = (async () => {
    const { data, error } = await supabase
      .from('configuracion_estudio')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(1);
    if (error) {
      console.error('[studio-config] fetch error:', error);
      return null;
    }
    cached = (data && data[0]) || null;
    loaded = true;
    notify();
    return cached;
  })();
  try { return await inflight; } finally { inflight = null; }
}

export function applyStudioConfig(next) {
  cached = next;
  loaded = true;
  notify();
}

export function useStudioConfig() {
  const [config, setConfig] = useState(cached);

  useEffect(() => {
    listeners.add(setConfig);
    if (!loaded) fetchConfigOnce();
    else setConfig(cached);
    return () => { listeners.delete(setConfig); };
  }, []);

  const refresh = useCallback(() => fetchConfigOnce(), []);
  return { config, refresh };
}
